import { Link, useLocation } from 'react-router';
import { useShell } from '@/context/shell-context';
import type { TLocalize } from '@hooks/use-localize';

interface IProps {
    link: string | null;
    t: TLocalize;
}

const BackToDashboard = ({ link, t }: IProps) => {
    const { pathname } = useLocation();
    const shell = useShell();

    const dashboardLink = link ? link :
        shell.registrationId > 0 && !pathname.startsWith('/register/donate')
            ? '/register/donate/'
            : '';

    return (
        <>
            {dashboardLink ?
                <Link to={dashboardLink} className="btn btn-default block" style={{ marginRight: 0 }}>
                    &laquo; {t('DashLabel_BackToDashboard', 'Back to Dashboard')}
                </Link>
                :
                null
            }
        </>
    );
}

export default BackToDashboard;
